const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
export default delay;



// WEBPACK FOOTER //
// ./src/util/delay.js